import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";

import { ok } from "@/lib/openapi";

import internalApi from "../../internal-base";
import { useNewsletterId } from "../utils";

export const useHappeningsQuery = () => {
  const newsletterId = useNewsletterId();

  const query = useQuery({
    queryKey: [newsletterId, "home", "happenings"],
    async queryFn({ signal }) {
      const data = await ok(
        internalApi.get("/happenings", {
          signal,
        })
      );

      return data.results;
    },
  });

  return query;
};

export const useBlockersQuery = () => {
  const newsletterId = useNewsletterId();

  const query = useQuery({
    queryKey: [newsletterId, "home", "blockers"],
    async queryFn({ signal }) {
      const data = await ok(
        internalApi.get("/blockers", {
          signal,
        })
      );

      return data.results;
    },
  });

  return query;
};

export const useTodosQuery = () => {
  const newsletterId = useNewsletterId();

  const query = useQuery({
    queryKey: [newsletterId, "home", "todos"],
    async queryFn({ signal }) {
      const data = await ok(
        internalApi.get("/todos", {
          signal,
        })
      );

      return data.results;
    },
  });

  return query;
};

export const useSkipTodoMutation = () => {
  const newsletterId = useNewsletterId();
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn(todoId: string) {
      const data = await ok(
        internalApi.post("/todos/{todo_id}/skip", {
          params: {
            path: {
              todo_id: todoId,
            },
          },
        })
      );
      return data;
    },
    async onSuccess() {
      await queryClient.invalidateQueries({
        queryKey: [newsletterId, "home", "todos"],
      });
    },
  });
};
